// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Select = require("../Select/index.js");
var Select_Setters = require("../Select.Setters/index.js");
var Clear = (function () {
    function Clear(value0) {
        this.value0 = value0;
    };
    Clear.create = function (value0) {
        return new Clear(value0);
    };
    return Clear;
})();
var Selected = (function () {
    function Selected(value0) {
        this.value0 = value0;
    };
    Selected.create = function (value0) {
        return new Selected(value0);
    };
    return Selected;
})();
var Cleared = (function () {
    function Cleared() {

    };
    Cleared.value = new Cleared();
    return Cleared;
})();
var toggle = function (dictShow) {
    return function (props) {
        return function (st) {
            return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("dropdown__trigger") ])([ Halogen_HTML_Elements.button(Select_Setters.setToggleProps(Data_Semigroup.append(Data_Semigroup.semigroupArray)(props)([ Lunarbox_Component_Utils.className("dropdown__trigger-button") ])))([ Halogen_HTML_Core.text(Data_Maybe.fromMaybe(st.placeholder)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Show.show(dictShow))(st.selected))) ]) ]);
        };
    };
};
var menu = function (dictShow) {
    return function (st) {
        return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("dropdown__menu") ])([ (function () {
            var $13 = Data_Eq.eq(Select.eqVisibility)(st.visibility)(Select.Off.value);
            if ($13) {
                return Halogen_HTML_Core.text("");
            };
            return Halogen_HTML_Elements.div(Select_Setters.setContainerProps([ Lunarbox_Component_Utils.className("dropdown__content") ]))(Data_Array.mapWithIndex(function (ix) {
                return function (item) {
                    return Halogen_HTML_Elements.div(Select_Setters.setItemProps(ix)((function () {
                        var v = Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqInt))(new Data_Maybe.Just(ix))(st.highlightedIndex);
                        if (v) {
                            return [ Lunarbox_Component_Utils.className("dropdown__item") ];
                        };
                        return [ Lunarbox_Component_Utils.className("dropdown__item") ];
                    })()))([ Halogen_HTML_Core.text(Data_Show.show(dictShow)(item)) ]);
                };
            })(st.available));
        })() ]);
    };
};
var spec = function (dictMonadAff) {
    return function (dictShow) {
        return function (dictEq) {
            var render = function (st) {
                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className((function () {
                    var $15 = Data_Eq.eq(Select.eqVisibility)(st.visibility)(Select.On.value);
                    if ($15) {
                        return "dropdown dropdow--is-active";
                    };
                    return "dropdown";
                })()) ])([ toggle(dictShow)([  ])(st), menu(dictShow)(st) ]);
            };
            var handleQuery = function (v) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (st) {
                    var $17 = {};
                    for (var $18 in st) {
                        if ({}.hasOwnProperty.call(st, $18)) {
                            $17[$18] = st[$18];
                        };
                    };
                    $17.selected = Data_Maybe.Nothing.value;
                    $17.available = st.items;
                    return $17;
                }))(function () {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query_HalogenM.raise(Cleared.value))(function () {
                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value0));
                    });
                });
            };
            var handleEvent = function (v) {
                if (v instanceof Select.Selected) {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                        var mbItem = Data_Array.index(st.available)(v.value0);
                        return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(mbItem)(function (item) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                var $22 = {};
                                for (var $23 in v1) {
                                    if ({}.hasOwnProperty.call(v1, $23)) {
                                        $22[$23] = v1[$23];
                                    };
                                };
                                $22.selected = new Data_Maybe.Just(item);
                                $22.available = Data_Array.difference(dictEq)(st.items)([ item ]);
                                $22.visibility = Select.Off.value;
                                return $22;
                            }))(function () {
                                return Halogen_Query_HalogenM.raise(new Selected(item));
                            });
                        });
                    });
                };
                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
            };
            return {
                render: render,
                handleAction: Select.defaultSpec.handleAction,
                handleQuery: handleQuery,
                handleEvent: handleEvent,
                receive: Select.defaultSpec.receive,
                initialize: Select.defaultSpec.initialize,
                finalize: Select.defaultSpec.finalize
            };
        };
    };
};
var input = function (v) {
    return {
        inputType: Select.Toggle.value,
        search: Data_Maybe.Nothing.value,
        debounceTime: Data_Maybe.Nothing.value,
        getItemCount: function ($29) {
            return Data_Array.length((function (v1) {
                return v1.items;
            })($29));
        },
        selected: Data_Maybe.Nothing.value,
        available: v.items,
        items: v.items,
        placeholder: v.placeholder
    };
};
var clear = new Select.Query(Halogen_Query.tell(Clear.create));
var _dropdown = Data_Symbol.SProxy.value;
module.exports = {
    Clear: Clear,
    "_dropdown": _dropdown,
    clear: clear,
    spec: spec,
    toggle: toggle,
    menu: menu
};
